module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main container one-column content"
  }, [_c('div', {
    staticClass: "col-main"
  }, [_c('div', {
    staticClass: "account-ds"
  }, [_c('div', {
    staticClass: "bar bar-nav account-top-m"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.routerGo()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("message.checkout")))])])]), _vm._v(" "), (_vm.errormsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "error-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.errormsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "onestepcheckout-form"
    }
  }, [_c('div', {
    staticClass: "group-select",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('p', {
    staticClass: "onestepcheckout-description"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("message.welcome_to_checkout")) + "\n                ")]), _vm._v(" "), (_vm.isCustomerPassword && _vm.isGuest) ? _c('p', {
    staticClass: "onestepcheckout-login-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/customer/account/login",
      "id": "onestepcheckout-login-link"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("message.already_registered")) + "\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "onestepcheckout-threecolumns checkoutcontainer onestepcheckout-skin-generic onestepcheckout-enterprise"
  }, [_c('div', {
    staticClass: "onestepcheckout-column-left"
  }, [_c('div', {
    staticClass: "guest_address"
  }, [_c('div', {
    attrs: {
      "id": "billing_address"
    }
  }, [_c('ul', [_c('li', [_c('p', {
    staticClass: "onestepcheckout-numbers onestepcheckout-numbers-1"
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t("message.shipping_address")) + "\n\n                                        ")])]), _vm._v(" "), _c('li', [_c('div', [(_vm.address_list) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cart_address_id),
      expression: "cart_address_id"
    }],
    staticClass: "address_list",
    attrs: {
      "name": "address_id"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cart_address_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeAddressList()
      }]
    }
  }, [_vm._l((_vm.address_list), function(address, address_id) {
    return _c('option', {
      domProps: {
        "value": address_id
      }
    }, [_vm._v("\n                                                    " + _vm._s(address.address) + "\n                                                ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("\n                                                    " + _vm._s(_vm.$t("message.new_address")) + "\n                                                ")])], 2) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "billing_address_list_new",
    style: ('display:' + _vm.displayAddressDetails),
    attrs: {
      "id": "billing_address_list"
    }
  }, [_c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "input-box input-firstname"
  }, [_c('label', {
    attrs: {
      "for": "billing:firstname"
    }
  }, [_vm._v("\n                                                            " + _vm._s(_vm.$t("message.first_name")) + "\n                                                            "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cart_address.first_name),
      expression: "cart_address.first_name"
    }],
    staticClass: "required-entry input-text",
    attrs: {
      "id": "billing:firstname",
      "name": "billing[first_name]",
      "type": "text"
    },
    domProps: {
      "value": (_vm.cart_address.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cart_address, "first_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box input-lastname"
  }, [_c('label', {
    attrs: {
      "for": "billing:lastname"
    }
  }, [_vm._v("\n                                                            " + _vm._s(_vm.$t("message.last_name")) + "\n                                                            "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cart_address.last_name),
      expression: "cart_address.last_name"
    }],
    staticClass: "required-entry input-text",
    attrs: {
      "id": "billing:lastname",
      "name": "billing[last_name]",
      "type": "text"
    },
    domProps: {
      "value": (_vm.cart_address.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cart_address, "last_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "  input-box input-email"
  }, [_c('label', {
    attrs: {
      "for": "billing:email"
    }
  }, [_vm._v("\n                                                            " + _vm._s(_vm.$t("message.email_address")) + "\n                                                            "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cart_address.email),
      expression: "cart_address.email"
    }],
    staticClass: "validate-email required-entry input-text",
    attrs: {
      "title": "Email Address",
      "id": "billing:email",
      "name": "billing[email]",
      "type": "text"
    },
    domProps: {
      "value": (_vm.cart_address.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cart_address, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "customer_email_validation"
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "input-box input-telephone"
  }, [_c('label', {
    attrs: {
      "for": "billing:telephone"
    }
  }, [_vm._v("\n                                                            " + _vm._s(_vm.$t("message.telephone")) + " "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cart_address.telephone),
      expression: "cart_address.telephone"
    }],
    staticClass: "required-entry input-text",
    attrs: {
      "id": "billing:telephone",
      "title": "Telephone",
      "name": "billing[telephone]",
      "type": "text"
    },
    domProps: {
      "value": (_vm.cart_address.telephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cart_address, "telephone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "input-box input-address"
  }, [_c('label', {
    attrs: {
      "for": "billing:street1"
    }
  }, [_vm._v("\n                                                            " + _vm._s(_vm.$t("message.street"))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cart_address.street1),
      expression: "cart_address.street1"
    }],
    staticClass: "required-entry input-text onestepcheckout-address-line",
    attrs: {
      "id": "billing:street1",
      "name": "billing[street1]",
      "title": "Street Address 1",
      "type": "text"
    },
    domProps: {
      "value": (_vm.cart_address.street1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cart_address, "street1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cart_address.street2),
      expression: "cart_address.street2"
    }],
    staticClass: "input-text onestepcheckout-address-line",
    attrs: {
      "id": "billing:street2",
      "name": "billing[street2]",
      "title": "Street Address 2",
      "type": "text"
    },
    domProps: {
      "value": (_vm.cart_address.street2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cart_address, "street2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "input-box input-country"
  }, [_c('label', {
    attrs: {
      "for": "billing:country"
    }
  }, [_vm._v("\n                                                            " + _vm._s(_vm.$t("message.country")) + " \n                                                            "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }],
    staticClass: "billing_country validate-select",
    attrs: {
      "title": "Country",
      "id": "billing:country",
      "name": "billing[country]"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeCountry()
      }]
    }
  }, [_vm._l((_vm.countryArr), function(countryName, countryCode) {
    return [_c('option', {
      domProps: {
        "value": countryCode
      }
    }, [_vm._v(_vm._s(countryName))])]
  })], 2)])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "input-box input-state"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "billing:state"
    }
  }, [_vm._v("\n                                                            " + _vm._s(_vm.$t("message.state")) + "\n                                                            "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "state_html"
  }, [(!_vm.stateArr) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }],
    staticClass: "address_state input-text",
    attrs: {
      "id": "state",
      "name": "billing[state]",
      "title": "State",
      "type": "text"
    },
    domProps: {
      "value": (_vm.state)
    },
    on: {
      "change": function($event) {
        return _vm.changeState()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.state = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stateArr) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }],
    staticClass: "address_state validate-select",
    attrs: {
      "id": "address:state",
      "title": "State",
      "name": "billing[state]"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeState()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Please select region, state or province")]), _vm._v(" "), _vm._l((_vm.stateArr), function(stateName, stateCode) {
    return [_c('option', {
      domProps: {
        "value": stateCode
      }
    }, [_vm._v(_vm._s(stateName))])]
  })], 2) : _vm._e()])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "input-box input-city"
  }, [_c('label', {
    attrs: {
      "for": "billing:city"
    }
  }, [_vm._v("\n                                                            " + _vm._s(_vm.$t("message.city")) + " \n                                                            "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cart_address.city),
      expression: "cart_address.city"
    }],
    staticClass: "required-entry input-text",
    attrs: {
      "id": "billing:city",
      "title": "City",
      "name": "billing[city]",
      "type": "text"
    },
    domProps: {
      "value": (_vm.cart_address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cart_address, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "input-box input-zip"
  }, [_c('label', {
    attrs: {
      "for": "billing:zip"
    }
  }, [_vm._v("\n                                                            " + _vm._s(_vm.$t("message.zip_code")) + " \n                                                            "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cart_address.zip),
      expression: "cart_address.zip"
    }],
    staticClass: "validate-zip-international required-entry input-text",
    attrs: {
      "id": "billing:zip",
      "name": "billing[zip]",
      "title": "Zip Code",
      "type": "text"
    },
    domProps: {
      "value": (_vm.cart_address.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cart_address, "zip", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.isGuest) ? [_c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCustomerPassword),
      expression: "isCustomerPassword"
    }],
    attrs: {
      "name": "create_account",
      "id": "id_create_account",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCustomerPassword) ? _vm._i(_vm.isCustomerPassword, null) > -1 : (_vm.isCustomerPassword)
    },
    on: {
      "click": function($event) {
        return _vm.addCustomerPassword()
      },
      "change": function($event) {
        var $$a = _vm.isCustomerPassword,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCustomerPassword = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCustomerPassword = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCustomerPassword = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "for": "id_create_account"
    }
  }, [_vm._v("\n                                                                " + _vm._s(_vm.$t("message.create_an_account")) + "\n                                                                \n                                                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "label_create_account"
  })]), _vm._v(" "), _c('li', {
    style: ('display:' + _vm.customerPasswordDisplay),
    attrs: {
      "id": "onestepcheckout-li-password"
    }
  }, [_c('div', {
    staticClass: "input-box input-password"
  }, [_c('label', {
    attrs: {
      "for": "billing:customer_password"
    }
  }, [_vm._v("\n                                                                " + _vm._s(_vm.$t("message.password")) + "\n                                                                \n                                                            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer_password),
      expression: "customer_password"
    }],
    staticClass: "validate-password input-text customer_password",
    attrs: {
      "name": "billing[customer_password]",
      "id": "billing:customer_password",
      "title": "Password",
      "value": "",
      "type": "password"
    },
    domProps: {
      "value": (_vm.customer_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer_password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box input-password"
  }, [_c('label', {
    attrs: {
      "for": "billing:confirm_password"
    }
  }, [_vm._v("\n                                                                " + _vm._s(_vm.$t("message.confirm_password")) + "\n                                                                \n                                                            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm_password),
      expression: "confirm_password"
    }],
    staticClass: "validate-password input-text customer_confirm_password",
    attrs: {
      "name": "billing[confirm_password]",
      "title": "Confirm Password",
      "id": "billing:confirm_password",
      "value": "",
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirm_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirm_password = $event.target.value
      }
    }
  })])])] : _vm._e()], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "onestepcheckout-column-middle"
  }, [_c('div', {
    staticClass: "shipping_method_html"
  }, [_c('div', {
    staticClass: "onestepcheckout-shipping-method"
  }, [_c('p', {
    staticClass: "onestepcheckout-numbers onestepcheckout-numbers-2"
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("message.shipping_method")) + "\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "onestepcheckout-shipping-method-block"
  }, [_c('dl', {
    staticClass: "shipment-methods"
  }, _vm._l((_vm.shippings), function(shipping, index) {
    return _c('div', {
      staticClass: "shippingmethods"
    }, [_c('div', {
      staticClass: "flatrate"
    }, [_vm._v("\n                                                " + _vm._s(shipping.label) + "\n                                            ")]), _vm._v(" "), _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.shipping_method),
        expression: "shipping_method"
      }],
      staticClass: "validate-one-required-by-name",
      attrs: {
        "data-role": "none",
        "type": "radio",
        "id": 's_method_flatrate_flatrate' + shipping.shipping_i,
        "name": "shipping_method"
      },
      domProps: {
        "value": shipping.method,
        "checked": _vm._q(_vm.shipping_method, shipping.method)
      },
      on: {
        "change": [function($event) {
          _vm.shipping_method = shipping.method
        }, function($event) {
          return _vm.changeShipping()
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 's_method_flatrate_flatrate' + shipping.shipping_i
      }
    }, [_vm._v(_vm._s(shipping.name) + "\n                                                    "), _c('strong', [_c('span', {
      staticClass: "price"
    }, [_vm._v("\n                                                            " + _vm._s(shipping.symbol) + "\n                                                            " + _vm._s(shipping.cost) + "\n                                                        ")])])])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "onestepcheckout-payment-method"
  }, [_c('p', {
    staticClass: "onestepcheckout-numbers onestepcheckout-numbers-3"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("message.payment_method")) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "payment_info"
  }, [_c('div', {
    staticClass: "payment-methods"
  }, [(_vm.payments) ? _c('dl', {
    attrs: {
      "id": "checkout-payment-method-load"
    }
  }, [_vm._l((_vm.payments), function(payment, payment_key) {
    return [_c('dt', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_method),
        expression: "payment_method"
      }],
      staticClass: "radio validate-one-required-by-name",
      staticStyle: {
        "display": "inline"
      },
      attrs: {
        "id": 'p_method_' + payment_key,
        "name": "payment_method",
        "title": payment.label,
        "type": "radio"
      },
      domProps: {
        "value": payment_key,
        "checked": _vm._q(_vm.payment_method, payment_key)
      },
      on: {
        "change": function($event) {
          _vm.payment_method = payment_key
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'p_method_' + payment_key
      }
    }, [_vm._v("\n                                                    " + _vm._s(payment.label) + "\n                                                ")])]), _vm._v(" "), _c('dd', {
      staticClass: "payment-method",
      attrs: {
        "id": 'container_payment_method_' + payment_key
      }
    }, [_c('ul', {
      staticClass: "form-list",
      attrs: {
        "id": 'payment_form_' + payment_key
      }
    }, [_c('li', [(payment.imageUrl) ? _c('img', {
      staticStyle: {
        "margin": "10px 0 8px 0"
      },
      attrs: {
        "src": payment.imageUrl
      }
    }) : _vm._e()])])])]
  })], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "onestepcheckout-coupons"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "coupon-notice"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "op_block_title"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("message.coupon_codes")) + "\n                            ")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "id_couponcode"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("message.enter_your_coupon_code")) + "\n                                \n                            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coupon_code),
      expression: "coupon_code"
    }],
    staticClass: "input-text",
    staticStyle: {
      "color": "#777"
    },
    attrs: {
      "id": "id_couponcode",
      "name": "coupon_code"
    },
    domProps: {
      "value": (_vm.coupon_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coupon_code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "submitbutton add_coupon_submit",
    attrs: {
      "type": "button",
      "id": "onestepcheckout-coupon-add"
    },
    on: {
      "click": function($event) {
        return _vm.addCoupon()
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.couponLabel) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "coupon_add_log"
  })]), _vm._v(" "), _c('div', {
    staticClass: "onestepcheckout-coupons"
  }, [_c('div', {
    staticClass: "op_block_title"
  }, [_vm._v(_vm._s(_vm.$t("message.order_remark")))]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "id_couponcode"
    }
  }, [_vm._v(_vm._s(_vm.$t("message.fill_order_remark")))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_remark),
      expression: "order_remark"
    }],
    staticClass: "order_remark",
    staticStyle: {
      "width": "94%",
      "height": "100px",
      "padding": "10px"
    },
    attrs: {
      "name": "order_remark"
    },
    domProps: {
      "value": (_vm.order_remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order_remark = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "onestepcheckout-column-right"
  }, [_c('div', {
    staticClass: "review_order_view"
  }, [_c('p', {
    staticClass: "onestepcheckout-numbers onestepcheckout-numbers-4"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("message.review_your_order")) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "onestepcheckout-summary"
  }, [_c('table', {
    staticClass: "onestepcheckout-summary"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "image"
  }), _vm._v(" "), _c('th', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("message.name")))]), _vm._v(" "), _c('th', {
    staticClass: "qty"
  }, [_vm._v(_vm._s(_vm.$t("message.qty")))]), _vm._v(" "), _c('th', {
    staticClass: "total"
  }, [_vm._v(_vm._s(_vm.$t("message.subtotal")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cart_info.products), function(product) {
    return _c('tr', [_c('td', {
      staticClass: "image"
    }, [_c('router-link', {
      staticClass: "product-image",
      attrs: {
        "to": '/catalog/product/' + product.product_id
      }
    }, [_c('img', {
      attrs: {
        "src": product.imgUrl,
        "alt": "2121"
      }
    })])], 1), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_c('h2', {
      staticClass: "product-name"
    }, [_c('router-link', {
      staticClass: "product-image",
      attrs: {
        "to": '/catalog/product/' + product.product_id,
        "title": product.name
      }
    }, [_vm._v("\n                                                        " + _vm._s(product.name) + "\n                                                    ")])], 1), _vm._v(" "), (product.custom_option_info) ? _c('ul', _vm._l((product.custom_option_info), function(val, label) {
      return _c('li', [_vm._v("\n                                                        " + _vm._s(label) + ":\n                                                        " + _vm._s(val) + "\n                                                    ")])
    }), 0) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "qty"
    }, [_vm._v("\n                                                " + _vm._s(product.qty) + "\n                                            ")]), _vm._v(" "), _c('td', {
      staticClass: "total"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v("\n                                                    " + _vm._s(_vm.currency_info.symbol) + "\n                                                    " + _vm._s(product.product_row_price) + "\n                                                ")])])])
  }), 0)]), _vm._v(" "), _c('table', {
    staticClass: "onestepcheckout-totals"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("\n                                                " + _vm._s(_vm.$t("message.subtotal")) + "\n                                            ")]), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("\n                                                    " + _vm._s(_vm.currency_info.symbol) + "\n                                                    " + _vm._s(_vm.cart_info.product_total) + "\n                                                    \n                                                ")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                                                " + _vm._s(_vm.$t("message.shipping_cost")) + "\n                                            ")]), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("\n                                                    " + _vm._s(_vm.currency_info.symbol) + "\n                                                    " + _vm._s(_vm.cart_info.shipping_cost) + "\n                                                ")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                                                " + _vm._s(_vm.$t("message.discount")) + "\n                                            ")]), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("-" + _vm._s(_vm.currency_info.symbol) + " " + _vm._s(_vm.cart_info.coupon_cost) + "\n                                                ")])])]), _vm._v(" "), _c('tr', {
    staticClass: "grand-total"
  }, [_c('td', [_vm._v("\n                                                " + _vm._s(_vm.$t("message.grand_total")) + "\n                                            ")]), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.currency_info.symbol) + _vm._s(_vm.cart_info.grand_total) + "\n                                                ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "onestepcheckout-place-order"
  }, [_c('a', {
    staticClass: "large orange onestepcheckout-button",
    attrs: {
      "href": "javascript:void(0)",
      "id": "onestepcheckout-place-order"
    },
    on: {
      "click": function($event) {
        return _vm.submitOrder()
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("message.place_order_now")) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "onestepcheckout-place-order-loading",
    style: ('display:' + _vm.displaySubmitOrder)
  }, [_c('img', {
    attrs: {
      "src": "//img.fancyecommerce.com/images/opc-ajax-loader.gif"
    }
  }), _vm._v("  \n                                Please wait, processing your order...\n                            ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_vm._v(" ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d5d3cfe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/checkout/Onepage.vue
// module id = 246
// module chunks = 1